export const changeScopCode = async (ctx,event) => {
        const { newOrderModel,refreshModel } = ctx.props;
        const copyNewModel = { ...newOrderModel, U_FMB_SCOP_CODE: event.nativeEvent.target.value }
        await refreshModel(copyNewModel);
        ctx.props.scoopTools.cleanScoopFields()
    };